import React, { useState, useEffect } from 'react';

const API = '/api';

export default function Communities({ user, isAdmin }) {
  const [communities, setCommunities] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ name: '', description: '', icon: '🌐', banner_color: '#6200ea' });
  const [creating, setCreating] = useState(false);
  const [showModPanel, setShowModPanel] = useState(false);
  const [modUsername, setModUsername] = useState('');
  const [activeTab, setActiveTab] = useState('posts');
  const [memberSearch, setMemberSearch] = useState('');

  const ICONS = ['🌐','✍️','💰','🎮','🎵','🎨','📸','🏃','🍕','✈️','💻','📈','🎬','⚽','🌿','🔬','📚','🤖','🥧','🦁'];
  const COLORS = ['#6200ea','#10b981','#0d9488','#ef4444','#3b82f6','#3b82f6','#ec4899','#0891b2'];

  useEffect(() => { fetchCommunities(); }, []);

  const fetchCommunities = async () => {
    try {
      const headers = user ? { 'Authorization': `Token ${user.token}` } : {};
      const res = await fetch(`${API}/communities/`, { headers });
      setCommunities(await res.json());
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const fetchCommunity = async (slug) => {
    try {
      const headers = user ? { 'Authorization': `Token ${user.token}` } : {};
      const res = await fetch(`${API}/communities/${slug}/`, { headers });
      const data = await res.json();
      setSelected(data);
    } catch (err) { console.error(err); }
  };

  const joinLeave = async (slug) => {
    if (!user) { alert('Please login first!'); return; }
    try {
      const res = await fetch(`${API}/communities/${slug}/join/`, {
        method: 'POST',
        headers: { 'Authorization': `Token ${user.token}` }
      });
      const data = await res.json();
      fetchCommunities();
      if (selected?.slug === slug) fetchCommunity(slug);
    } catch (err) { console.error(err); }
  };

  const modAction = async (action, username, extra = {}) => {
    if (!user) return;
    try {
      const res = await fetch(`${API}/communities/${selected.slug}/mod/`, {
        method: 'POST',
        headers: { 'Authorization': `Token ${user.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ action, username: username || modUsername, ...extra })
      });
      const data = await res.json();
      alert(data.message || data.error);
      setModUsername('');
      fetchCommunity(selected.slug);
    } catch (err) { console.error(err); }
  };

  const createCommunity = async () => {
    if (!form.name.trim()) { alert('Name required!'); return; }
    setCreating(true);
    try {
      const res = await fetch(`${API}/communities/create/`, {
        method: 'POST',
        headers: { 'Authorization': `Token ${user.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (data.slug) {
        setShowCreate(false);
        setForm({ name: '', description: '', icon: '🌐', banner_color: '#6200ea' });
        fetchCommunities();
        fetchCommunity(data.slug);
      } else {
        alert(data.error || 'Error creating community');
      }
    } catch (err) { console.error(err); }
    setCreating(false);
  };

  if (selected) return (
    <div style={S.page}>
      {/* Banner */}
      <div style={{ ...S.banner, backgroundColor: selected.banner_color }}>
        <button onClick={() => setSelected(null)} style={S.backBtn}>←</button>
        <div style={S.bannerIcon}>{selected.icon}</div>
        <h1 style={S.bannerTitle}>{selected.name}</h1>
        <p style={S.bannerDesc}>{selected.description}</p>
        <div style={S.bannerStats}>
          <span>👥 {selected.member_count} members</span>
          <span>·</span>
          <span>📝 {selected.posts?.length || 0} posts</span>
          <span>·</span>
          <span>Created by @{selected.creator}</span>
        </div>
        <button onClick={() => joinLeave(selected.slug)} style={{ ...S.joinBtn, backgroundColor: selected.is_member ? 'rgba(255,255,255,0.2)' : 'white', color: selected.is_member ? 'white' : selected.banner_color }}>
          {selected.is_member ? '✓ Joined' : '+ Join'}
        </button>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:'8px', padding:'10px 20px', borderBottom:'1px solid #f0f0f0' }}>
        {['posts','members'].map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)}
            style={{ padding:'6px 16px', borderRadius:'15px', border:'none', cursor:'pointer', fontSize:'13px', fontWeight:'bold',
              backgroundColor: activeTab===tab ? '#6200ea' : '#f3e5f5',
              color: activeTab===tab ? 'white' : '#6200ea' }}>
            {tab === 'posts' ? '📝 Posts' : '👥 Members'}
          </button>
        ))}
      </div>

      {/* Posts */}
      <div style={S.content}>
        {activeTab === 'posts' && <h2 style={S.sectionTitle}>📝 Posts</h2>}
        {activeTab === 'members' && (
          <div>
            <h2 style={S.sectionTitle}>👥 Members ({selected.member_count})</h2>
            <input type="text" placeholder="🔍 Search members..."
              value={memberSearch} onChange={e => setMemberSearch(e.target.value)}
              style={{ width:'100%', padding:'10px', borderRadius:'10px', border:'2px solid #e0e0e0', fontSize:'14px', marginBottom:'12px', boxSizing:'border-box' }} />
            {(isAdmin ? (selected.members_list || []) : (selected.members_list || []).filter(m => true)).map((m, i) => (
              <a key={i} href={'/profile/' + m.username}
                style={{ display:'flex', alignItems:'center', gap:'10px', padding:'10px', backgroundColor:'white', borderRadius:'10px', marginBottom:'6px', textDecoration:'none', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
                {m.avatar
                  ? <img src={m.avatar} alt={m.username} style={{ width:'36px', height:'36px', borderRadius:'50%', objectFit:'cover' }} />
                  : <div style={{ width:'36px', height:'36px', borderRadius:'50%', backgroundColor:'#6200ea', color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'bold', fontSize:'14px' }}>{m.username[0].toUpperCase()}</div>
                }
                <div style={{ flex: 1, textAlign: 'left' }}>
                  <div style={{ color:'#333', fontWeight:'bold', fontSize:'14px' }}>{'@' + m.username}</div>
                  {selected.moderators && selected.moderators.includes(m.username) && <span style={{ color:'#0d9488', fontSize:'11px' }}>🛡️ Mod</span>}
                  {selected.creator === m.username && <span style={{ color:'#6200ea', fontSize:'11px' }}>👑 Creator</span>}
                </div>
                {isAdmin && m.username !== user?.username && m.username !== 'khalidxpert' && (
                  <div style={{ display:'flex', gap:'4px' }}>
                    <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); modAction(selected.moderators?.includes(m.username) ? 'remove_mod' : 'add_mod', m.username); }}
                      style={{ backgroundColor: selected.moderators?.includes(m.username) ? '#0d9488' : '#10b981', color:'white', border:'none', padding:'4px 8px', borderRadius:'6px', cursor:'pointer', fontSize:'11px' }}>
                      {selected.moderators?.includes(m.username) ? '➖Mod' : '➕Mod'}
                    </button>
                    <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); if(window.confirm('Remove member?')) modAction('remove_member', m.username); }}
                      style={{ backgroundColor:'#ef4444', color:'white', border:'none', padding:'4px 8px', borderRadius:'6px', cursor:'pointer', fontSize:'11px' }}>
                      🚫
                    </button>
                  </div>
                )}

              </a>
            ))}
          </div>
        )}
        {activeTab === 'posts' && <h2 style={{display:'none'}}></h2>}
        {activeTab === 'posts' && (
          selected.posts?.length === 0 ? (
            <div style={S.empty}>No posts yet in this community</div>
          ) : (
          selected.posts?.map(p => (
            <div key={p.id} style={{ ...S.postCard, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <a href={`/post/${p.id}`} style={{ textDecoration: 'none', flex: 1 }}>
                <div style={S.postTitle}>{p.title}</div>
                <div style={S.postMeta}>@{p.author} · {p.created_at} · 👍 {p.total_votes}</div>
              </a>
              {(isAdmin || (user && selected.creator === user.username)) && (
                <button onClick={() => { if(window.confirm('Remove from community?')) modAction('remove_post', { post_id: p.id }); }}
                  style={{ backgroundColor: '#ef4444', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', flexShrink: 0 }}>✕</button>
              )}
            </div>
          ))
          )
        )}
      </div>
    </div>
  );

  return (
    <div style={S.page}>
      <div style={S.header}>
        <h1 style={S.title}>🌐 Communities</h1>
        {user && (
          <button onClick={() => setShowCreate(!showCreate)} style={S.createBtn}>
            {showCreate ? '✕ Cancel' : '+ Create'}
          </button>
        )}
      </div>

      {/* Create Form */}
      {showCreate && (
        <div style={S.createForm}>
          <h3 style={{ color: '#6200ea', margin: '0 0 14px' }}>Create Community</h3>
          <input style={S.input} placeholder="Community name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
          <textarea style={S.input} placeholder="Description" rows={3} value={form.description} onChange={e => setForm({...form, description: e.target.value})} />
          <div style={{ marginBottom: '12px' }}>
            <label style={S.label}>Icon</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              {ICONS.map(ic => (
                <span key={ic} onClick={() => setForm({...form, icon: ic})}
                  style={{ fontSize: '20px', cursor: 'pointer', padding: '4px', borderRadius: '8px', backgroundColor: form.icon === ic ? '#f3e5f5' : 'transparent', border: form.icon === ic ? '2px solid #6200ea' : '2px solid transparent' }}>
                  {ic}
                </span>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={S.label}>Color</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              {COLORS.map(c => (
                <div key={c} onClick={() => setForm({...form, banner_color: c})}
                  style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: c, cursor: 'pointer', border: form.banner_color === c ? '3px solid #333' : '3px solid transparent' }} />
              ))}
            </div>
          </div>
          <button onClick={createCommunity} disabled={creating} style={S.createBtn}>
            {creating ? 'Creating...' : '🚀 Create Community'}
          </button>
        </div>
      )}

      {/* Communities List */}
      {loading ? <div style={S.empty}>Loading...</div> : (
        <div style={S.list}>
          {communities.map(c => (
            <div key={c.id} style={S.card} onClick={() => fetchCommunity(c.slug)}>
              <div style={{ ...S.cardIcon, backgroundColor: c.banner_color }}>{c.icon}</div>
              <div style={S.cardInfo}>
                <div style={S.cardName}>{c.name} {c.is_default && <span style={S.defaultBadge}>Official</span>}</div>
                <div style={S.cardDesc}>{c.description.substring(0, 60)}...</div>
                <div style={S.cardMeta}>👥 {c.member_count} · 📝 {c.post_count}</div>
              </div>
              <button onClick={(e) => { e.stopPropagation(); joinLeave(c.slug); }}
                style={{ ...S.joinBtnSmall, backgroundColor: c.is_member ? '#10b981' : '#6200ea' }}>
                {c.is_member ? '✓' : '+'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const S = {
  page: { maxWidth: '700px', margin: '0 auto', paddingBottom: '30px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 10px' },
  title: { color: '#6200ea', margin: 0 },
  createBtn: { backgroundColor: '#6200ea', color: 'white', border: 'none', padding: '10px 18px', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' },
  createForm: { margin: '0 20px 16px', backgroundColor: 'white', borderRadius: '16px', padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  input: { width: '100%', padding: '10px', borderRadius: '10px', border: '2px solid #e0e0e0', fontSize: '14px', marginBottom: '12px', boxSizing: 'border-box', fontFamily: 'inherit' },
  label: { display: 'block', color: '#666', fontSize: '13px', fontWeight: 'bold', marginBottom: '6px' },
  list: { padding: '0 20px', display: 'flex', flexDirection: 'column', gap: '10px' },
  card: { backgroundColor: 'white', borderRadius: '14px', padding: '14px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer' },
  cardIcon: { width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', flexShrink: 0 },
  cardInfo: { flex: 1 },
  cardName: { fontWeight: 'bold', color: '#333', fontSize: '15px', display: 'flex', alignItems: 'center', gap: '6px' },
  cardDesc: { color: '#999', fontSize: '12px', marginTop: '2px' },
  cardMeta: { color: '#bbb', fontSize: '11px', marginTop: '4px' },
  defaultBadge: { backgroundColor: '#6200ea', color: 'white', fontSize: '10px', padding: '2px 6px', borderRadius: '8px', fontWeight: 'bold' },
  joinBtnSmall: { color: 'white', border: 'none', width: '32px', height: '32px', borderRadius: '50%', cursor: 'pointer', fontSize: '18px', fontWeight: 'bold', flexShrink: 0 },
  banner: { padding: '30px 20px 20px', textAlign: 'center', color: 'white', position: 'relative' },
  backBtn: { position: 'absolute', top: '16px', left: '16px', backgroundColor: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', padding: '6px 12px', borderRadius: '15px', cursor: 'pointer', fontSize: '16px' },
  bannerIcon: { fontSize: '48px', marginBottom: '8px' },
  bannerTitle: { fontSize: '28px', fontWeight: '900', margin: '0 0 8px' },
  bannerDesc: { color: 'rgba(255,255,255,0.8)', fontSize: '14px', margin: '0 0 10px' },
  bannerStats: { display: 'flex', gap: '8px', justifyContent: 'center', fontSize: '12px', color: 'rgba(255,255,255,0.7)', marginBottom: '12px', flexWrap: 'wrap' },
  joinBtn: { border: 'none', padding: '10px 24px', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '15px' },
  content: { padding: '16px 20px' },
  sectionTitle: { color: '#6200ea', marginBottom: '12px' },
  postCard: { display: 'block', backgroundColor: 'white', borderRadius: '12px', padding: '14px', marginBottom: '8px', textDecoration: 'none', boxShadow: '0 2px 6px rgba(0,0,0,0.08)' },
  postTitle: { fontWeight: 'bold', color: '#333', fontSize: '15px', marginBottom: '4px' },
  postMeta: { color: '#999', fontSize: '12px' },
  empty: { textAlign: 'center', padding: '40px', color: '#999' },
};
